import { Injectable } from '@angular/core'
import { Configuration, Feature } from '../types'
import { environment } from '../../environments/environment'
import { version, buildDate, commitHash } from '../../environments/version'
import { LanguageService } from './language.service'
import { ReplaySubject } from 'rxjs'

@Injectable({
   providedIn: 'root'
})
export class ConfigService {

   // these will be removed if debug is set to false from apiParams
   private apiParamsDebug = ['environment']

   private featuresfromApi: Feature[] = []
   private featuresFromUrl = ''

   changeEnv(env: string) {
      if (this.debug){
         if (this.config?.apiParams) {
            this.config.apiParams['environment'] = env
         }
         else {
            this.config.apiParams = {environment: env}
         }
      }
   }

   changeCache(cache: string) {
      this.debugCache = cache
   }

   debugCache = 'false'
   debug = false
   researchHistoryDays = 7
   maxHistorySizeDefault = 200

   private config!: Configuration
   // Add subscriptioon to config changes, only buffer the latest change (1)
   onConfigChange$: ReplaySubject<Configuration> = new ReplaySubject<Configuration>(1)

   get features() {
      return this.featuresfromApi
   }

   get showSideNav() {
      return this.config.showSideNav ?? null
   }

   get currentConfig () {
      return this.config
   }

   get apiUrl() {
      return this.config.apiUrl ?? environment.apiUrl
   }

   get product() {
      return this.config.product
   }

   get apiParams() {
      return this.config.apiParams ?? {}
   }
   get language() {
      return this.languageService.language
   }

   constructor(private languageService: LanguageService) {
      // TODO retrieve initial config from the server?
      this.config = {
         isStandalone: true,
         apiUrl: environment.apiUrl,
         height: '100vh',
         language: languageService.language,
         libraryName: '',
         product: 'standalone',
         showBeta: true,
         showSideNav: null,
         showToast: true,
         showAdvanced: true,
         streamAnswer: false,
         enableOnline: false,
         enableHistory: false,
         howToCiteLink: '',
         maxHistorySize: this.maxHistorySizeDefault,
         researchHistoryDays: this.researchHistoryDays,
         llmModel: '' //TODO: default version?
      }
   }

   /**
    * doesn't need to set the full config, the existing config will be amended
    * @param (partial) config object
    */
   setConfig(config: Configuration) {
      this.config = { ...this.config, ...config}
      // make sure we use the configured language
      this.languageService.changeLanguage(this.config.language)
      this.onConfigChange$.next(this.config)
   }

   setStreaming(streaming: boolean) {
      this.config.streamAnswer = streaming
   }

   setLlmModel(model: string) {
      this.config.llmModel = model
      this.onConfigChange$.next(this.config)
   }

   toggleSideNav(what: boolean | null) {
      if (this.config) {
         this.config.showSideNav = what
      }
   }

   getVersion(): string {
      return `Version ${version}, commit ${commitHash}, built at ${buildDate}`
   }

   setDebug(debug: boolean) {
      this.debug = debug
      if (debug)  {
         this.changeCache('false')
      }
      if (!debug) {
         for (const param of this.apiParamsDebug) {
            if(this.config.apiParams && this.config.apiParams[param]) {
               delete this.config.apiParams[param]
            }
         }
      }
   }

   setFeatures(features: Feature[]) {
      this.featuresfromApi = features
      this.setFeaturesFromString(this.featuresFromUrl)
   }

   setFeatureFromString(features: string) {
      this.featuresFromUrl = features
      this.setFeaturesFromString(features)
   }

   private setFeaturesFromString(fString: string) {
      if(fString && fString.includes(':')) {
         fString.split(',').forEach(f => {
            const keyValue = f.split(':')
            const feature = this.featuresfromApi.find(feat => feat.key === keyValue[0])
            if (feature) {
               feature.value = keyValue[1]
            }
         })
      }
   }



}
